import { injectable } from 'tsyringe';
import { ApiRoutes } from '../apiConfig/ApiRoutes';
import { BaseApi } from '../apiConfig/BaseApi';
import { UserSummary } from '$src/domain/users/UserSummary';
import { IUserRepository } from '$src/domain/users/IUserRepository';
import { UserGroupStoreAccess } from '$src/domain/users/UserGroupStoreAccess';

@injectable()
export class UserRepositoryApi extends BaseApi implements IUserRepository {
  
    private static ROUTES = 
    {
        Me: 'me',
        MyGroupStores: 'me/groupstores'
    };

    protected static getRoute(path: string) : string {
        return `${ApiRoutes.USERS.endpoint}/${path}`;
    }
    
    async getMe(): Promise<UserSummary> {
        try {

            const route = UserRepositoryApi.getRoute(UserRepositoryApi.ROUTES.Me);

            const response = await this.apiClient.get<UserSummary>(route);
            
            return response;
        } catch (error) {
            console.error('Error fetching getMe:', error);
            throw error; 
        }
    }

    async getMyGroupStores(): Promise<UserGroupStoreAccess> {
        try {

            const route = UserRepositoryApi.getRoute(UserRepositoryApi.ROUTES.MyGroupStores);

            const response = await this.apiClient.get<UserGroupStoreAccess>(route);
            
            return response;
        } catch (error) {
            console.error('Error fetching getMyGroupStores:', error);
            throw error; 
        }
    }
}
